module.exports = __webpack_public_path__ + "static/media/github.366fbf15.png";